import { Checkbox, FormGroup, TextInput } from '@ksyos/design-system';
import { useState } from 'react';
import type { JournalEntryType } from '@common/enums';
import type { IJournal } from '@common/validation/episodesAndJournal';
import type { ValidationErrors } from '@frontend/utils';
import { InputTextCheckbox } from '@frontend/components/elements/InputTextCheckbox';

interface IJournalTypeCheckboxProps {
    errors?: ValidationErrors;
    journalEntry: IJournal;
    journalType: JournalEntryType;
    onChange: (updatedJournalEntry: IJournal) => void;
    variant: 'outline' | 'flushed';
}
export function JournalTypeCheckbox(props: IJournalTypeCheckboxProps) {
    const { errors, onChange, journalEntry, journalType, variant } = props;
    const [isChecked, setIsChecked] = useState(!!journalEntry[journalType]);

    const component =
        variant === 'outline' ? (
            <div style={{ alignItems: 'center', display: 'flex' }}>
                <Checkbox
                    checked={isChecked}
                    onChange={async (event) => {
                        setIsChecked(!isChecked);
                        if (!event.target.checked) {
                            onChange({ ...journalEntry, [journalType]: undefined });
                        }
                    }}
                />

                <TextInput
                    onChange={async (event) => {
                        setIsChecked(!!event.target.value);
                        onChange({ ...journalEntry, [journalType]: event.target.value });
                    }}
                    placeholder=""
                    style={{ marginLeft: '12px' }}
                    value={journalEntry[journalType] || ''}
                />
            </div>
        ) : (
            <InputTextCheckbox
                error={errors?.get(journalType)}
                key={`${journalEntry.episodeValueDisplayName}_${journalType}`}
                labelStyle={{ width: '100%' }}
                onChange={async (text, checked) => {
                    if (checked && text) {
                        onChange({ ...journalEntry, [journalType]: text });
                    } else {
                        onChange({ ...journalEntry, [journalType]: undefined });
                    }
                }}
                onDoValidate={() => {
                    /* @TODO*/
                }}
                placeholder=""
                text={journalEntry[journalType] ?? null}
            />
        );

    return (
        <FormGroup
            hasErrors={errors?.has(journalType)}
            key={journalType}
            label={journalType}
        >
            {component}
        </FormGroup>
    );
}
